import { render, staticRenderFns } from "./Feet.vue?vue&type=template&id=2d816b9a&scoped=true&"
import script from "./Feet.vue?vue&type=script&lang=js&"
export * from "./Feet.vue?vue&type=script&lang=js&"
import style0 from "./Feet.vue?vue&type=style&index=0&id=2d816b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d816b9a",
  null
  
)

export default component.exports